function setTitle(title: string) {
    document.title = `${title} - DPS Forms Management Console - NHS England`;
}

export { setTitle };
